import { getFileExtForSport } from '@low6-pickem/sports-config';

export function normalizeTeamLogoUrl(url: string): string {
  const match = url.match(/^(.*\/)([^/?#]+)\/teams\/([^/?#]+)\.([a-z0-9]+)([?#].*)?$/i);
  if (!match) {
    return url;
  }

  const [, prefix, sport, teamCode, currentExt, suffix = ''] = match;
  const expectedExt = getFileExtForSport(sport);

  if (currentExt.toLowerCase() === expectedExt) {
    return url;
  }

  return `${prefix}${sport}/teams/${teamCode}.${expectedExt}${suffix}`;
}
